export const initDivSent = () => {
	document.addEventListener(`click`, (evt) => {
		if (evt.target.closest(`div.sent`) && evt.target.tagName.toLowerCase() === `button`)
		{
			evt.target.closest(`form`).classList.remove(`sent`, `success`, `error`);
		}
	});
};
